import type { InstantSearch } from "instantsearch.js";
import { map, atom } from "nanostores";

export type SortingList = {
  id: string;
  label: string;
};

export const $search = map({});
export const $filters = map({});
export const $sortOptions = atom<SortingList[]>([]);
export const $selectedSort = atom<string>("");
export const $isFilterBarLoaded = atom(false);
export const $resultsCount = atom(0);
export const $pagination = map({
  current: 0,
  total: 0,
  totalVisibleProducts: 11,
});

export const setSearchInstance = (instance: Partial<InstantSearch>) => {
  $search.set(instance);
};

export const setSortOptions = (options: SortingList[]) => {
  $sortOptions.set(options);
};

export const setSelectedSort = (sort: string) => {
  $selectedSort.set(sort);
};

export const setResultsCount = (count: number) => $resultsCount.set(count);

export const setIsFilterBarLoaded = (isLoaded: boolean) =>
  $isFilterBarLoaded.set(isLoaded);

export const setPagination = ({
  current,
  total,
  totalVisibleProducts,
}: {
  current: number;
  total?: number;
  totalVisibleProducts?: number;
}) => {
  $pagination.set({
    current: current,
    total: total || $pagination.get().total,
    totalVisibleProducts:
      totalVisibleProducts || $pagination.get().totalVisibleProducts,
  });
};
